var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49989 0H10.9999V2.06186C12.5481 2.25491 13.9588 2.89033 15.1018 3.83765L16.5408 2.3986L17.6015 3.45926L16.1624 4.89833C17.1604 6.10246 17.8122 7.60387 17.9652 9.24999H20L20 10.75H17.9652C17.8121 12.3961 17.1603 13.8976 16.1623 15.1017L17.6014 16.5408L16.5407 17.6014L15.1017 16.1624C13.9588 17.1096 12.548 17.745 10.9999 17.9381V20H9.49989V17.9846C7.75585 17.877 6.163 17.2107 4.89818 16.1624L3.4592 17.6014L2.39854 16.5407L3.83751 15.1018C2.83948 13.8976 2.18765 12.3962 2.03458 10.75H0V9.24999H2.03458C2.18763 7.60376 2.83949 6.10227 3.83754 4.89811L2.3986 3.45916L3.45926 2.3985L4.89822 3.83746C6.16304 2.7892 7.75587 2.12288 9.49989 2.01533V0ZM9.99989 3.49996C6.41004 3.49996 3.49989 6.41011 3.49989 9.99996C3.49989 13.5898 6.41004 16.5 9.99989 16.5C13.5897 16.5 16.4999 13.5898 16.4999 9.99996C16.4999 6.41011 13.5897 3.49996 9.99989 3.49996Z",
    fill: "#39414A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.068b1da733b4648bf89112bb6ab76a9a.svg";
export { ForwardRef as ReactComponent };